export default __webpack_public_path__ + "static/media/river.2734c498.svg";